<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  position="top"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h4>
      {{ 'revenue.credit-card-activity.details.title' | translate | ucfirst }}
    </h4>
  </ng-template>

  <div class="atlas-form mct-gap-27"  *ngIf="transactionSummaryItem">
    <div class="mct-grid mct-cols-2-1" >
      <div class="mct-gap-11" >
        <wl-profile-type-icon [profileId]="transactionSummaryItem.ProfileId"></wl-profile-type-icon>
        <a> {{ transactionSummaryItem.ReportName }} </a>
      </div>
      <div clas="t-ar">
        {{ transactionSummaryItem.DateChanged | date: 'MM/dd/yyyy' }}
      </div>
    </div>
    <div class="mct-grid mct-cols-1-1-1" >
      <div>
        <label>
          {{ 'revenue.credit-card-activity.invoice-num' | translate | ucfirst }}
        </label>
        <div>
          {{ transactionSummaryItem.InvoiceNum }}
        </div>
      </div>
      <div>
        <label>
          {{ 'revenue.credit-card-activity.amount' | translate | ucfirst }}
        </label>
        <div>
          {{ transactionSummaryItem.Amount | currency }}
        </div>
      </div>
      <div>
        <label>
          {{ 'revenue.credit-card-activity.details.status' | translate | ucfirst }}
        </label>
        <div [ngSwitch]="transactionSummaryItem.CurrentState">
          <span *ngSwitchCase="transactionStateEnum.Processed" class="f-green">
            {{ 'revenue.credit-card-activity.processed' | translate | uppercase }}
          </span>
          <span *ngSwitchCase="transactionStateEnum.Refunded" class="f-grey">
            {{ 'revenue.credit-card-activity.refunded' | translate | uppercase }}
          </span>
          <span *ngSwitchCase="transactionStateEnum.Voided" class="f-grey">
            {{ 'revenue.credit-card-activity.voided' | translate | uppercase }}
          </span>
          <span *ngSwitchCase="transactionStateEnum.Undefined" class="alert-icon">
            <img src="/assets/img/alert-icon.svg" />
          </span>
        </div>
      </div>
    </div>
    <hr />
    <div class="mct-flex mct-col" >
      <label>
        {{ 'revenue.credit-card-activity.details.transaction-result' | translate | ucfirst }}
      </label>
      <div>
        {{ transactionSummaryItem.TransactionResult }}
      </div>
    </div>
    <hr />
    <div class="mct-grid mct-cols-2-1" >
      <div>
        <label>
          {{ 'revenue.credit-card-activity.name-on-card' | translate | ucfirst }}
        </label>
        <div>
          {{ transactionSummaryItem.NameOnCard }}
        </div>
      </div>
      <div>
        <label>
          {{ 'revenue.credit-card-activity.details.card-last-four' | translate | ucfirst }}
        </label>
        <div>
          {{
            transactionSummaryItem.CardNum.length > 4
              ? transactionSummaryItem.CardNum.substr(transactionSummaryItem.CardNum.length - 4)
              : transactionSummaryItem.CardNum
          }}
        </div>
      </div>
    </div>
    <div class="mct-grid mct-cols-2-1" >
      <div>
        <label>
          {{ 'revenue.credit-card-activity.details.billing-address' | translate | ucfirst }}
        </label>
        <div [hidden]="!transactionSummaryItem.Address1">{{ transactionSummaryItem.Address1 }}</div>
        <div [hidden]="!transactionSummaryItem.Address2">{{ transactionSummaryItem.Address2 }}</div>
        <div [hidden]="!transactionSummaryItem.City && !transactionSummaryItem.State && !transactionSummaryItem.Zip">
          {{ transactionSummaryItem.City ? transactionSummaryItem.City + ', ' : '' }}
          {{ transactionSummaryItem.State }}
          {{
            transactionSummaryItem.ZipExt ? transactionSummaryItem.Zip + '-' + transactionSummaryItem.ZipExt : transactionSummaryItem.Zip
          }}
        </div>
      </div>
      <div>
        <label>
          {{ 'revenue.credit-card-activity.details.card-exipration-date' | translate | ucfirst }}
        </label>
        <div>
          {{ transactionSummaryItem.ValidThrough }}
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-end mct-items-center mct-gap-10"    >
      <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="show = false">
        {{ 'common.close' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
